import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  play: false,
  die: false,
  speed: 0,
  score: 0,
  lastScore: 0,
  loadingScreen: true,
  pause: false,
};

export const engineSlice = createSlice({
  name: "engine",
  initialState,
  reducers: {
    setReady: (state, action) => {
      state.play = action.payload;
    },
    setDie: (state, action) => {
      state.die = action.payload;
    },
    setSpeed: (state, action) => {
      state.speed += action.payload;
    },
    setScore: (state, action) => {
      state.score = action.payload;
    },
    incrementScore: (state, action) => {
      state.score += action.payload;
    },
    setLastScore: (state, action) => {
      state.lastScore = action.payload;
    },
    setLoadingScreen: (state, action) => {
      state.loadingScreen = action.payload;
    },
    setPause: (state, action) => {
      state.pause = action.payload;
    },
  },
});

export const {
  setReady,
  setDie,
  setSpeed,
  setScore,
  incrementScore,
  setLastScore,
  setLoadingScreen,
  setPause,
} = engineSlice.actions;

export default engineSlice.reducer;
